export const common = {
  format(val) {
    if (val < 10) {
      return '0' + val
    } else {
      return val
    }
  },
  formatDate() {
    var d = new Date()
    var year = d.getFullYear()
    var month = change(d.getMonth() + 1)
    var day = change(d.getDate())
    var hour = change(d.getHours())
    var minute = change(d.getMinutes())
    var second = change(d.getSeconds())
    function change(t) {
      if (t < 10) {
        return '0' + t
      } else {
        return t
      }
    }
    var time = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
    return time
  },
  formatter(numInt) {
    var resultInt = ''
    while (numInt.length > 3) {
      resultInt = ',' + numInt.slice(-3) + resultInt
      numInt = numInt.slice(0, numInt.length - 3)
    }
    if (numInt) {
      resultInt = numInt + resultInt
    }
    return resultInt
  },
  formatNames(name) {
    const names = {
      Home: '首页',
      'Mobile Malware Detection': '移动病毒检测',
      'URL Filtering': 'URL网址安全检测',
      'App Insight': '应用深度分析',
      'Android/iOS WiFi Security Detection': '安卓/iOS Wifi安全检测',
      'APP Insight Detail': '应用深度分析详情',
      Payment: '支付',
      Settings: '设置',
      Support: '支持',
      'App Insights': '应用深度分析',
      'Android/iOS Wifi Security Detection': '安卓/iOS Wifi安全检测',
      'No Subscription': '没有订阅'
    }
    return names[name]
  },
  formatTypes(type) {
    const types = {
      monthly: '每月',
      'One Time Package': '每次'
    }
    return types[type]
  }
}



// WEBPACK FOOTER //
// ./src/views/public/common.js